import { Injectable } from "@angular/core";
import { ConfigStoreService } from "../services/config.store.service";
import { CurrentUser } from "./currentuser.model";
import { List } from 'immutable';
import { Customer, Department } from "../features/customer/customer.model";

interface StoreItem<T> {
    set: (value: T) => void;
    get: () => T;
    clear: () => void;
}

export interface DashboardAccordionState {
    userEvents: boolean;
    syncOverview: boolean;
}

@Injectable({
    providedIn: 'root'
})

export class MainStore
{
    static readonly CurrentUserId: string = '[main-configurator-web] currentuser';
    static readonly DepartmentListId: string = '[main-configurator-web] departmentlist';
    static readonly SelectedDepartmentId: string = '[main-configurator-web] selecteddepartment';
    static readonly ErrorId: string = '[main-configurator-web] error';
    static readonly SelectedCustomer: string = '[main-configurator-web] selectedcustomer';
    static readonly DashboardAccordionState: string = '[main-configurator-web] dashboard-accordion-state';

    //Available properties (session/cookie storage)
    public currentUser: StoreItem<CurrentUser>;
    public departmentList: StoreItem<Department[]>;
    public selectedDepartment: StoreItem<Department | null>;
    public error: StoreItem<any>;
    public selectedCustomerId: StoreItem<number>;

    //Available properties (localStorage)
    public dashboardAccordionState: StoreItem<DashboardAccordionState>;


    constructor( private configStoreService: ConfigStoreService) {
        this.currentUser = this.createCookieStoreItem<CurrentUser>(MainStore.CurrentUserId, { name: '', userName: '', departmentCode: '', departmentName:'', departmentId:'', isAdmin: false});
        this.departmentList = this.createCookieStoreItem<Department[]>(MainStore.DepartmentListId, []);
        this.selectedDepartment = this.createCookieStoreItem<Department | null>(MainStore.SelectedDepartmentId, null);
        this.error = this.createCookieStoreItem<any>(MainStore.ErrorId, '');
        this.selectedCustomerId = this.createCookieStoreItem<number>(MainStore.SelectedCustomer, -1);
        
        this.dashboardAccordionState = this.createLocalStoreItem<DashboardAccordionState>(MainStore.DashboardAccordionState, { userEvents: true, syncOverview: true });
     }

    private createCookieStoreItem<T>(key: string, defaultValue: T): StoreItem<T> {
        return {
            set: (value: T) => this.configStoreService.setCookie(key, value),
            get: (): T => this.configStoreService.getCookie<T>(key) ?? defaultValue ,
            clear: () => this.configStoreService.removeCookie(key)
        };
    }

    private createLocalStoreItem<T>(key: string, defaultValue: T): StoreItem<T> {
        return {
            set: (value: T) => this.configStoreService.setLocal(key, value),
            get: (): T => this.configStoreService.getLocal<T>(key, defaultValue) ?? defaultValue,
            clear: () => this.configStoreService.removeLocal(key)
        };
    }
}
